import CryptoJS from 'crypto-js';

export default class StorageService {

  constructor() {
    this.hashMap = {};
    this.keySalt = 'phaiy7aeHieX`ieV';
    this.eKey = 'Xuhahxu7si3Ke]z@';
    this.bypass = [
      'language',
      'appVersion',
    ];
    [
      'latestYear',
      'userLocation',
      'userAddress',
      'currentMapProvice',
      'schoolData',
      'school_average',
      'areaNames',
    ].forEach(key => this.migrate(key));
  }
  hashKey(key) {
    if (this.hashMap[key]) {
      return this.hashMap[key];
    }
    this.hashMap[key] = CryptoJS.SHA1(key + this.keySalt).toString().substr(2, 16);

    return this.hashMap[key];
  }
  migrate(key) {
    const stored = localStorage.getItem(key);
    if (stored === null) {
      return false;
    }
    const len = stored.length;
    if (stored.substr(4, 1) !== '=' || stored.substr(len-5, 1) !== '=') {
      this.setItem(key, stored);
    }
    localStorage.removeItem(key);
  }
  getItem(key) {
    if (this.bypass.indexOf(key) !== -1) {
      return localStorage.getItem(key);
    }
    this.migrate(key);
    const h = this.hashKey(key);
    const stored = localStorage.getItem(h);
    if (stored === null) {
      return null;
    }
    const len = stored.length;
    if (stored.substr(4, 1) !== '=' || stored.substr(len-5, 1) !== '=') {
      localStorage.removeItem(h);
      return null;
    }
    const data = CryptoJS.AES.decrypt(
      stored.substr(5, len - 10),
      CryptoJS.SHA1(this.eKey + stored.substr(0, 4) + stored.substr(len - 4)).toString()
    ).toString(CryptoJS.enc.Utf8);
    if (!data) {
      localStorage.removeItem(h);
      return null;
    }
    return data;
  }
  generateSalt() {
    return CryptoJS.lib.WordArray.random(4).toString(CryptoJS.enc.Hex);
  }

  setItem(key, value) {
    if (this.bypass.indexOf(key) !== -1) {
      return localStorage.setItem(key, value);
    }
    const salt = this.generateSalt();
    localStorage.setItem(this.hashKey(key),
      salt.substr(0, 4)
   + '='
   +  CryptoJS.AES.encrypt(value, CryptoJS.SHA1(this.eKey + salt).toString())
   + '='
   + salt.substr(4)
    )
  }
  removeItem(key) {
    localStorage.removeItem(this.hashKey(key));
  }
}
